<!-- Lo que esta pantalla NO hace, dicho antes de que alguien suba nada. -->
<div class="co-note">
  <i class="fa-solid fa-circle-info"></i>
  <span
    >Esto <b>lee</b> el estado de cuenta, le pone nombre a cada movimiento y dice si ya está registrado.
    <b>No registra ni aplica ningún pago</b>: eso sigue siendo del alta de pagos.</span
  >
</div>

<div class="co-upload" *ngIf="!resultado && !cargando">
  <div class="co-drop">
    <i class="fa-solid fa-building-columns"></i>
    <p class="co-drop-title">Sube el estado de cuenta</p>
    <p class="co-drop-sub">Tal como lo descargas del banco: Covalto (.xls) o Santander (.csv). También .xlsx.</p>

    <div class="co-bank">
      <label for="co-bank">Banco</label>
      <select id="co-bank" [(ngModel)]="banco">
        <option *ngFor="let b of bancos" [value]="b.value">{{ b.label }}</option>
      </select>
    </div>

    <p-fileUpload
      mode="basic"
      chooseLabel="Elegir archivo"
      [auto]="true"
      [customUpload]="true"
      accept=".xls,.xlsx,.csv"
      invalidFileTypeMessageSummary="{0}: no es un estado de cuenta que se pueda leer."
      invalidFileTypeMessageDetail="Sube el archivo del banco en .xls, .xlsx o .csv."
      (uploadHandler)="subir($event)"
      styleClass="p-button-sm"
    ></p-fileUpload>
  </div>
</div>

<div class="co-skeleton" *ngIf="cargando">
  <p-skeleton height="3rem" styleClass="mb-2"></p-skeleton>
  <p-skeleton height="12rem"></p-skeleton>
</div>

<ng-container *ngIf="resultado && !cargando">
  <!--
    Con el catálogo vacío la regla más fuerte no puede correr. Va arriba y en rojo: sin esto, la
    primera corrida parece un fallo del motor en vez de un catálogo que nadie cargó.
  -->
  <div class="co-alert" *ngIf="avisoCatalogo">
    <i class="fa-solid fa-triangle-exclamation"></i>
    <span>{{ avisoCatalogo }}</span>
  </div>

  <!-- El banco elegido a mano no es el del archivo: el resultado puede PARECER bueno y no serlo. -->
  <div class="co-alert" *ngIf="resultado.bankWarning">
    <i class="fa-solid fa-triangle-exclamation"></i>
    <span>{{ resultado.bankWarning }}</span>
  </div>

  <!--
    Con qué se leyó y qué traía el archivo. Es lo primero que se compara contra el estado de cuenta
    en papel: si el total de abonos no coincide, nada de lo de abajo es de fiar.
  -->
  <div class="co-file">
    <span
      ><b>{{ archivo }}</b> · leído como <b>{{ bancoLeido }}</b
      ><ng-container *ngIf="resultado.detected"> (detectado por sus columnas)</ng-container></span
    >
    <span>{{ resultado.readRows }} movimientos</span>
    <span
      >Abonos <b>{{ resultado.reconciliation.totals.amounts.inflows | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</b></span
    >
    <span *ngIf="totalCargos"
      >Cargos <b>{{ -totalCargos | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</b></span
    >
  </div>

  <div class="co-bar">
    <div class="co-chips">
      <button type="button" class="co-chip is-ok" [class.is-act]="filtro === 'IDENTIFICADO'" (click)="alternar('IDENTIFICADO')">
        <b>{{ cuantos('IDENTIFICADO') }}</b> identificados
        <span class="co-chip-amt">{{
          resultado.reconciliation.totals.amounts.identified | currency: 'MXN' : 'symbol-narrow' : '1.0-0'
        }}</span>
      </button>
      <button type="button" class="co-chip is-bad" [class.is-act]="filtro === 'POR_IDENTIFICAR'" (click)="alternar('POR_IDENTIFICAR')">
        <b>{{ cuantos('POR_IDENTIFICAR') }}</b> por identificar
        <span class="co-chip-amt">{{
          resultado.reconciliation.totals.amounts.unidentified | currency: 'MXN' : 'symbol-narrow' : '1.0-0'
        }}</span>
      </button>
      <button type="button" class="co-chip" [class.is-act]="filtro === 'INTERNO_TRASPASO'" (click)="alternar('INTERNO_TRASPASO')">
        <b>{{ cuantos('INTERNO_TRASPASO') }}</b> internos
        <span class="co-chip-amt">{{
          resultado.reconciliation.totals.amounts.internal | currency: 'MXN' : 'symbol-narrow' : '1.0-0'
        }}</span>
      </button>
      <button type="button" class="co-chip" [class.is-act]="filtro === 'EGRESO'" (click)="alternar('EGRESO')">
        <b>{{ cuantos('EGRESO') }}</b> egresos
        <span class="co-chip-amt">{{
          -resultado.reconciliation.totals.amounts.outflows | currency: 'MXN' : 'symbol-narrow' : '1.0-0'
        }}</span>
      </button>
    </div>

    <div class="co-summary">
      <span class="co-rate">{{ tasa }} identificado</span>
      <!-- El dinero que entró y no se pudo explicar. Es la cifra que duele, y por eso va en rojo. -->
      <span class="co-unid" *ngIf="resultado.reconciliation.totals.unidentifiedAmount > 0">
        {{ resultado.reconciliation.totals.unidentifiedAmount | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }} sin explicar
      </span>
      <!--
        La hoja de carga con lo que el banco ya dijo. Solo aparece si hay algo que registrar, y el
        rótulo lleva el número: sin él, quien la baja no sabe si trae veinte filas o ninguna.

        NO registra nada. El archivo se sube al asistente de «Cargar pagos del día» como cualquier
        otro, y ahí siguen el previo, el aviso de duplicados y la confirmación.
      -->
      <button
        *ngIf="paraRegistrar"
        pButton
        type="button"
        class="p-button-sm p-button-outlined"
        icon="fa-solid fa-file-excel"
        [label]="'Hoja de carga · ' + paraRegistrar"
        pTooltip="Los identificados por su cuenta o su RFC que aún no están registrados, en el layout de «Cargar pagos del día»"
        tooltipPosition="bottom"
        [loading]="generando"
        (click)="descargarCarga()"
      ></button>
      <!-- La conciliación en .xlsx con la estructura de la hoja de Contabilidad. No registra nada. -->
      <button
        pButton
        type="button"
        class="p-button-sm p-button-outlined"
        icon="fa-solid fa-file-arrow-down"
        label="Descargar conciliación"
        pTooltip="Movimientos, resumen y verificación contra CENTRAL y CARTERA, como la hoja de Contabilidad"
        tooltipPosition="bottom"
        [loading]="exportando"
        [disabled]="exportando"
        (click)="descargarConciliacion()"
      ></button>
      <button
        pButton
        type="button"
        class="p-button-sm p-button-text"
        icon="fa-solid fa-rotate"
        label="Otro archivo"
        (click)="otroArchivo()"
      ></button>
    </div>
  </div>

  <!--
    ¿Lo identificado ya está en la plataforma? Es la columna «✓ CUADRA / DIFERENCIA / NO APLICADO» de
    la hoja de Contabilidad, y lo que dice qué falta registrar o aplicar.
  -->
  <div class="co-verif" *ngIf="cuantos('IDENTIFICADO')">
    <span class="co-verif-lbl">Contra lo registrado:</span>
    <button type="button" class="co-chip is-ok" [class.is-act]="filtroVerificacion === 'CUADRA'" (click)="alternarVerificacion('CUADRA')">
      <b>{{ resultado.reconciliation.totals.byVerification.CUADRA }}</b> ✓ cuadran
    </button>
    <button
      type="button"
      class="co-chip is-warn"
      [class.is-act]="filtroVerificacion === 'DIFERENCIA'"
      (click)="alternarVerificacion('DIFERENCIA')"
    >
      <b>{{ resultado.reconciliation.totals.byVerification.DIFERENCIA }}</b> con diferencia
    </button>
    <button
      type="button"
      class="co-chip is-bad"
      [class.is-act]="filtroVerificacion === 'NO_APLICADO'"
      (click)="alternarVerificacion('NO_APLICADO')"
    >
      <b>{{ resultado.reconciliation.totals.byVerification.NO_APLICADO }}</b> no aplicados
    </button>
  </div>

  <!-- Las filas que el lector no pudo interpretar. No se tiran en silencio. -->
  <div class="co-skipped" *ngIf="resultado.skipped.length">
    <b>{{ resultado.skipped.length }}</b> de {{ resultado.readRows }} filas no se pudieron leer:
    <span *ngFor="let s of resultado.skipped.slice(0, 6)">fila {{ s.row }} ({{ s.reason }})</span>
    <span *ngIf="resultado.skipped.length > 6">y {{ resultado.skipped.length - 6 }} más</span>
  </div>

  <div class="co-empty" *ngIf="!movimientos.length">No hay movimientos con ese filtro.</div>

  <div class="co-scroll" *ngIf="movimientos.length">
    <table class="co-table">
      <thead>
        <tr>
          <th>Fecha</th>
          <th class="co-num">Importe</th>
          <th>Cliente</th>
          <th>Cómo</th>
          <th>Referencia</th>
          <th>Cuenta ordenante</th>
          <th>Contrato</th>
          <th>Detalle</th>
          <th>Registrado</th>
          <th>Estatus</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let m of movimientos" [class.is-bad]="m.status === 'POR_IDENTIFICAR'">
          <td>{{ m.date | date: 'dd/MM/yyyy' : 'UTC' }}</td>
          <td class="co-num" [class.co-out]="m.amount < 0">{{ m.amount | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</td>
          <td class="co-client">
            <ng-container *ngIf="m.clientName">{{ m.clientName }}</ng-container>
            <!-- Sin identificar, el nombre que da el banco es la mejor pista para buscarlo a mano. -->
            <span class="co-hint" *ngIf="!m.clientName && m.originName" pTooltip="Así lo nombra el banco" tooltipPosition="top">{{
              m.originName
            }}</span>
            <ng-container *ngIf="!m.clientName && !m.originName">—</ng-container>
          </td>
          <td class="co-rule">{{ regla(m) }}</td>
          <td class="co-mono">{{ m.reference || '—' }}</td>
          <td class="co-mono co-nowrap">
            {{ m.originClabe || '—' }}
            <!--
              Identificado por el RFC pero con una cuenta que el catálogo no conoce: se ofrece
              guardarla. Así el siguiente estado de cuenta —también el de Covalto, que no da RFC— lo
              reconoce por su cuenta.
            -->
            <button
              *ngIf="puedeGuardarCuenta(m)"
              pButton
              type="button"
              class="p-button-sm p-button-text co-save"
              icon="fa-solid fa-floppy-disk"
              pTooltip="Guardar esta cuenta en el catálogo del cliente"
              tooltipPosition="top"
              [attr.aria-label]="'Guardar la cuenta ' + m.originClabe + ' en el catálogo'"
              [loading]="guardandoCuenta === m.originClabe"
              (click)="guardarCuenta(m)"
            ></button>
          </td>
          <td class="co-leases">
            <ng-container *ngIf="m.suggestedLeases?.length; else sinContrato">
              <span
                *ngFor="let c of m.suggestedLeases.slice(0, 2)"
                class="co-lease"
                [class.is-match]="c.matchesAmount"
                [pTooltip]="c.matchesAmount ? 'Tiene una letra abierta de este mismo importe' : 'Arrendamiento activo del cliente'"
                tooltipPosition="top"
                >{{ c.noId ? 'ID ' + c.noId : c.folio }}</span
              >
              <span class="co-hint" *ngIf="m.suggestedLeases.length > 2">+{{ m.suggestedLeases.length - 2 }}</span>
            </ng-container>
            <ng-template #sinContrato>—</ng-template>
          </td>
          <td class="co-desc" [pTooltip]="m.reason || m.description" tooltipPosition="top">
            <!-- Cuando hay un porqué —interno o sin identificar—, desplaza a la descripción: es lo accionable. -->
            {{ m.reason || m.description }}
          </td>
          <td>
            <p-tag
              *ngIf="m.verification"
              [severity]="severidadVerificacion(m.verification)"
              [value]="etiquetaVerificacion(m.verification)"
              [pTooltip]="m.verificationDetail || ''"
              tooltipPosition="left"
            ></p-tag>
            <ng-container *ngIf="!m.verification">—</ng-container>
          </td>
          <td><p-tag [severity]="severidad(m.status)" [value]="etiqueta(m.status)"></p-tag></td>
        </tr>
      </tbody>
    </table>
  </div>

  <ul class="co-caveats">
    <li *ngFor="let c of resultado.reconciliation.caveats">{{ c }}</li>
  </ul>
</ng-container>

<p-toast position="top-right"></p-toast>
